/**
 * Mobile-only: keep Dondy WhatsApp chat centered.
 * Size stays CSS-driven (adaptive). JS only locks center position.
 */
(function () {
  var MOBILE_MQ = '(max-width: 767px)';
  var pinned = false;

  function pinChatWindow() {
    if (!window.matchMedia(MOBILE_MQ).matches) return;

    var win = document.querySelector(
      '#whatsapp-widget-root .chat-fade-wrapper.open .chat-window, .chat-fade-wrapper.open .chat-window'
    );
    if (!win) {
      pinned = false;
      return;
    }

    win.style.setProperty('position', 'fixed', 'important');
    win.style.setProperty('top', '50%', 'important');
    win.style.setProperty('left', '50%', 'important');
    win.style.setProperty('right', 'auto', 'important');
    win.style.setProperty('bottom', 'auto', 'important');
    win.style.setProperty('margin', '0', 'important');
    win.style.setProperty('visibility', 'visible', 'important');
    win.style.setProperty('z-index', '2147483647', 'important');
    win.style.setProperty('transform-origin', 'center center', 'important');
    // Size left to CSS. Keep centered with translate after open animation.
    if (!pinned) {
      pinned = true;
      setTimeout(function () {
        if (!win.isConnected) return;
        win.style.setProperty('transform', 'translate(-50%, -50%) scale(1)', 'important');
        win.style.setProperty('-webkit-transform', 'translate(-50%, -50%) scale(1)', 'important');
      }, 380);
    }
  }

  function schedulePin() {
    if (!window.matchMedia(MOBILE_MQ).matches) return;
    pinChatWindow();
    requestAnimationFrame(pinChatWindow);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('#chat-bubble, #whatsapp-link, .whatsapp-widget')) {
        pinned = false;
        schedulePin();
      }
    },
    true
  );

  var observer = new MutationObserver(function () {
    if (!window.matchMedia(MOBILE_MQ).matches) return;
    var open = document.querySelector('.chat-fade-wrapper.open .chat-window');
    if (open) schedulePin();
    else pinned = false;
  });

  function start() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
